/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcome_Landing_SubheadingInputs */

const en_welcome_landing_subheading = /** @type {(inputs: Welcome_Landing_SubheadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hosted by Vega`)
};

/**
* | output |
* | --- |
* | "Hosted by Vega" |
*
* @param {Welcome_Landing_SubheadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const welcome_landing_subheading = /** @type {((inputs?: Welcome_Landing_SubheadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Landing_SubheadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_welcome_landing_subheading(inputs)
});